import React, { useState } from 'react'
import styled from 'styled-components';
import netlifyIdentity from 'netlify-identity-widget'

import Header from '../../components/Header/index'
import Footer from '../../components/Footer/index'
import Registers from '../../components/Dash/index'
import Container from '../../layout/container';

const Button = styled.button`
  color: #fff;
  padding: 20px;
  margin: 150px auto 50px;
  background: #65987C;
  border: 1px solid #65987C;
  border-radius: 4px;
`;

const Dashboard = () => {
  netlifyIdentity.init({});
  const currentUser = netlifyIdentity.currentUser();
  const [user, setUser] = useState();

  return user || currentUser ? (
    <>
      <Header page="dash" />
      <Registers />
      <Footer />
    </>
  ) : (
    <>
      <Header page="dash" />
      <Container>
        <Button onClick={() => {netlifyIdentity.open()}}>
          Log in
        </Button>
      </Container>
      <Footer />
    </>
  )
};

export default Dashboard;
